// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__CtRmY","label":"style__label__aWHVM","toggle":"style__toggle__MyZOz","slider":"style__slider__IuNSc","circle":"style__circle__G3m0m"};